import React, { Fragment, Component } from "react";
import { withRouter } from "react-router";
import {
  Col,
  Container,
  Row,
  Spinner,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import IndexBloc from "../Blocs/IndexBloc";
import { Pie } from "react-chartjs-2";
import apiResponse from "../../../../../services/apiResponse";
import Select from "react-select";
import {
  Document,
  Packer,
  Paragraph,
  ImageRun,
  TextRun,
  AlignmentType,
} from "docx";
import { saveAs } from "file-saver";
import image from "../../../../../assets/images/BKPM NEW 1.png";

class IndexView extends Component {
  indexBloc = new IndexBloc();

  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.state = {
      data: null,
      loading: false,
      diskOption: [],
      selectedGraphId: "",
      hoveredDesc: false,
      errorMessage: null,
    };
  }

  loadData() {
    this.setState({ loading: true });

    this.indexBloc.getAllSpaceUtilizationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          let errormessage = result.data.message;
          const diskOptions = Array.isArray(response)
            ? Array.from(
                new Set(
                  response.flatMap((item) =>
                    item.graphs.map((graph) => graph.name)
                  )
                )
              ).map((name) => ({ value: name, label: name }))
            : [];

          const { selectedHost } = this.props;
          const hostId = selectedHost.value;

          const specificHost = Array.isArray(response)
            ? response.find((item) => item.hostid === hostId)
            : null;

          const graphNames =
            specificHost && Array.isArray(specificHost.graphs)
              ? specificHost.graphs.map((graph) => graph.name)
              : [];

          const filteredDiskOptions = diskOptions.filter((option) =>
            graphNames.includes(option.label)
          );

          const firstFilteredDiskOption =
            filteredDiskOptions.length > 0 ? filteredDiskOptions[0] : null;

          this.setState({
            data: response,
            diskOption: filteredDiskOptions,
            selectedGraphId: firstFilteredDiskOption,
            loading: false,
            errorMessage: errormessage,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            errorMessage: "Failed to load data. Please try again.",
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.fetchAllGraphSpaceUtilizationAll({});
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    const { selectedHost } = this.props;
    if (prevProps.selectedHost.value !== selectedHost.value) {
      this.loadData();
    }
  }

  handleGraphIdChange = (selectedOption) => {
    this.setState({ selectedGraphId: selectedOption });
  };

  convertToBytes(valueWithUnit) {
    const [value, unit] = valueWithUnit.split(" ");
    const numericValue = parseFloat(value);

    switch (unit) {
      case "KB":
        return numericValue * 1e3;
      case "MB":
        return numericValue * 1e6;
      case "GB":
        return numericValue * 1e9;
      case "TB":
        return numericValue * 1e12;
      case "B":
      case undefined:
        return numericValue;
      default:
        throw new Error(`Unknown unit: ${unit}`);
    }
  }

  convert(valueInBytes) {
    if (valueInBytes >= 1e12) {
      return `${(valueInBytes / 1e12).toFixed(2)} TB`;
    } else if (valueInBytes >= 1e9) {
      return `${(valueInBytes / 1e9).toFixed(2)} GB`;
    } else if (valueInBytes >= 1e6) {
      return `${(valueInBytes / 1e6).toFixed(2)} MB`;
    } else if (valueInBytes >= 1e3) {
      return `${(valueInBytes / 1e3).toFixed(2)} KB`;
    } else {
      return `${valueInBytes.toFixed(2)} Bytes`;
    }
  }

  createChart() {
    const { selectedGraphId } = this.state;
    const { selectedHost } = this.props;

    const defaultChartData = {
      labels: [],
      datasets: [],
    };

    if (!selectedHost) {
      return defaultChartData;
    }

    const hostId = selectedHost.value;

    const specificHost = Array.isArray(this.state.data)
      ? this.state.data.find((item) => item.hostid === hostId)
      : null;

    const graphs =
      specificHost && Array.isArray(specificHost.graphs)
        ? specificHost.graphs
        : [];

    const getGraphIdFromSelected = (selected) => {
      if (!selected || !selected.value) return null;

      const foundGraph = graphs.find((graph) => graph.name === selected.value);
      return foundGraph ? foundGraph.graphid : null;
    };

    const graphId = getGraphIdFromSelected(selectedGraphId);

    const graphItems =
      specificHost && Array.isArray(specificHost.graphs)
        ? specificHost.graphs
            .filter((graph) => graph.graphid === graphId)
            .flatMap((graph) => graph.items)
        : [];

    // const filteredItems = graphItems.filter(
    //   (item) =>
    //     item.name !== "/: Total space" && item.name !== "/boot: Total space"
    // );

    let availableSpace = 0;
    let usedSpace = 0;
    let totalSpace = 0;

    let availableLabel = "";
    let usedLabel = "";
    // let totalLabel = "";

    let availableColor = "";
    let usedColor = "";
    // let totalColor = "";

    graphItems.forEach((item) => {
      switch (item.name) {
        case "/: Used space":
          usedSpace = this.convertToBytes(item.last);
          usedLabel = `${item.name}`;
          usedColor = "rgba(0, 131, 0, 0.8)";
          break;
        case "/: Total space":
          totalSpace = this.convertToBytes(item.last);
          // totalLabel = `${item.name}`;
          // totalColor = "rgba(176, 0, 0, 0.8)";
          break;
        case "/boot: Used space":
          usedSpace = this.convertToBytes(item.last);
          usedLabel = `${item.name}`;
          usedColor = "rgba(0, 131, 0, 0.8)";
          break;
        case "/boot: Total space":
          totalSpace = this.convertToBytes(item.last);
          // totalLabel = `${item.name}`;
          // totalColor = "rgba(176, 0, 0, 0.8)";
          break;
        default:
          totalSpace = this.convertToBytes(item.last);
          // totalLabel = `${item.name}`;
          // totalColor = "rgba(0, 0, 0, 0.53)";
          break;
      }
    });

    availableSpace = totalSpace - usedSpace;
    availableLabel = "Available space";
    availableColor = "rgba(128, 0, 128, 0.8)";

    return {
      labels: [usedLabel, availableLabel],
      datasets: [
        {
          data: [usedSpace, availableSpace],
          backgroundColor: [usedColor, availableColor],
          hoverBackgroundColor: [usedColor, availableColor],
        },
      ],
    };
  }

  renderDiskInfo = () => {
    const { selectedGraphId } = this.state;
    const { selectedHost } = this.props;

    const hostId = selectedHost.value;

    const specificHost = Array.isArray(this.state.data)
      ? this.state.data.find((item) => item.hostid === hostId)
      : null;

    const graphs =
      specificHost && Array.isArray(specificHost.graphs)
        ? specificHost.graphs
        : [];

    const getGraphIdFromSelected = (selected) => {
      if (!selected || !selected.value) return null;

      const foundGraph = graphs.find((graph) => graph.name === selected.value);
      return foundGraph ? foundGraph.graphid : null;
    };

    const graphId = getGraphIdFromSelected(selectedGraphId);

    const graphItems =
      specificHost && Array.isArray(specificHost.graphs)
        ? specificHost.graphs
            .filter((graph) => graph.graphid === graphId)
            .flatMap((graph) => graph.items)
        : [];

    const usedSpace = graphItems.find(
      (item) =>
        item.name === "/: Used space" || item.name === "/boot: Used space"
    );
    const totalSpace = graphItems.find(
      (item) =>
        item.name === "/: Total space" || item.name === "/boot: Total space"
    );

    const used = usedSpace ? this.convertToBytes(usedSpace.last) : "0.00 GB";
    const total = totalSpace ? this.convertToBytes(totalSpace.last) : "0.00 GB";

    const available = total - used;

    const sortedItems = [
      { name: "/: Used space", value: used },
      { name: "Available space", value: available },
      { name: "/: Total space", value: total },
    ];

    if (graphItems.length === 0) {
      return <div>No Space information available for the selected host.</div>;
    }

    return (
      <div>
        <div>
          <div style={{ fontWeight: "bold", fontSize: "20px" }}>
            Informasi{" "}
            <span
              className="uil-info-circle"
              onMouseEnter={() => this.setState({ hoveredDesc: true })}
              onMouseLeave={() => this.setState({ hoveredDesc: false })}
              style={{ cursor: "pointer" }}
            />
          </div>
          <br />
        </div>
        {this.state.hoveredDesc && (
          <div
            style={{
              position: "absolute",
              background: "#f4f4f4",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "10px",
              zIndex: 1000,
              width: "900px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            }}
          >
            {this.renderDescDescriptions()}
          </div>
        )}

        {sortedItems.map((item, index) => (
          <div key={index}>
            <strong>{item.name}</strong> : <strong>Nilai:</strong>{" "}
            {this.convert(item.value)}
          </div>
        ))}
      </div>
    );
  };

  renderDescDescriptions = () => {
    const { selectedGraphId } = this.state;
    const { selectedHost } = this.props;

    const hostId = selectedHost.value;

    const specificHost = Array.isArray(this.state.data)
      ? this.state.data.find((item) => item.hostid === hostId)
      : null;

    const graphs =
      specificHost && Array.isArray(specificHost.graphs)
        ? specificHost.graphs
        : [];

    const getGraphIdFromSelected = (selected) => {
      if (!selected || !selected.value) return null;

      const foundGraph = graphs.find((graph) => graph.name === selected.value);
      return foundGraph ? foundGraph.graphid : null;
    };

    const graphId = getGraphIdFromSelected(selectedGraphId);

    const graphItems =
      specificHost && Array.isArray(specificHost.graphs)
        ? specificHost.graphs
            .filter((graph) => graph.graphid === graphId)
            .flatMap((graph) => graph.items)
        : [];

    console.log(graphItems);

    const descriptions = {
      "Used space":
        "Jumlah kapasitas penyimpanan atau ruang disk yang sudah digunakan oleh file, aplikasi, dan data sistem.",
      "Available space":
        "Jumlah kapasitas penyimpanan atau ruang disk yang saat ini masih kosong dan belum terpakai.",
      "Total space":
        "Kapasitas penyimpanan keseluruhan atau ukuran total dari disk atau sistem penyimpanan.",
    };

    const sortedItems = [
      { name: "Used space", description: descriptions["Used space"] },
      { name: "Available space", description: descriptions["Available space"] },
      { name: "Total space", description: descriptions["Total space"] },
    ];

    return (
      <div>
        {sortedItems.map((item, index) => (
          <div key={index}>
            <strong>{item.name}:</strong> {item.description}
          </div>
        ))}
      </div>
    );
  };

  handleDownloadWord = () => {
    const chartInstance = this.chartRef;

    if (!chartInstance) {
      console.error("Chart instance not found.");
      return;
    }

    const imgData = chartInstance.toBase64Image();

    const { selectedHost } = this.props;
    const value = selectedHost.label;

    const { selectedGraphId } = this.state;
    const disk = selectedGraphId.label;

    const currentDate = new Date();
    const options = { day: "numeric", month: "long", year: "numeric" };
    const formattedDate = currentDate.toLocaleDateString("id-ID", options);

    const chartData = this.createChart();
    const analysisResults = this.analyzeChartData(chartData);

    const analysisParagraphs = analysisResults.map(
      (result) =>
        new Paragraph({
          spacing: { after: 80 },
          children: [
            new TextRun({
              text: `Grafik ${result.label}: Nilai ${result.averageUsed} & Space Available ${result.selisih} (`,
              font: "Arial",
              size: 20,
            }),
            new TextRun({
              text: result.status,
              font: "Arial",
              size: 20,
              bold: true,
            }),
            new TextRun({
              text: `)`,
              font: "Arial",
              size: 20,
            }),
          ],
        })
    );

    let paragraphText;
    if (this.allGood(analysisResults)) {
      paragraphText =
        "Disk space dalam kondisi baik menunjukkan bahwa kapasitas penyimpanan masih cukup tersedia, dengan penggunaan belum mencapai 50% dari total ruang yang ada. Kondisi ini mengindikasikan bahwa sistem memiliki ruang penyimpanan yang memadai untuk menangani kebutuhan saat ini maupun tambahan data di masa mendatang tanpa khawatir akan kehabisan ruang. Secara keseluruhan, ini adalah situasi yang ideal untuk mendukung stabilitas dan kinerja sistem, serta memberikan fleksibilitas untuk pengelolaan data dan aplikasi tanpa hambatan.";
    } else if (this.allWarning(analysisResults)) {
      paragraphText =
        "Disk space dalam kondisi warning menunjukkan bahwa ruang penyimpanan mulai menipis, dengan sisa kapasitas kurang dari 50% dari total ruang yang tersedia. Kondisi ini mengindikasikan bahwa meskipun sistem masih dapat beroperasi, perlu dilakukan pemantauan yang lebih ketat untuk memastikan kapasitas tidak terus berkurang hingga mencapai level kritis. Untuk mencegah gangguan pada kinerja sistem.";
    } else if (this.allBad(analysisResults)) {
      paragraphText =
        "Disk space dalam kondisi buruk menunjukkan bahwa kapasitas penyimpanan hampir habis, dengan sisa ruang kurang dari 20% dari total yang tersedia. Kondisi ini harus segera ditangani karena dapat menyebabkan gangguan serius pada kinerja sistem.";
    }

    this.convertImageToBase64(image).then((base64Image) => {
      const doc = new Document({
        sections: [
          {
            properties: {},
            children: [
              // COVER PAGE
              new Paragraph({
                spacing: {
                  after: 500,
                },
                alignment: AlignmentType.RIGHT,
                children: [
                  new ImageRun({
                    data: base64Image,
                    transformation: { width: 250, height: 50 },
                  }),
                ],
              }),

              new Paragraph({
                spacing: {
                  after: 2000,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Report Maintenance",
                    font: "Arial",
                    size: 60,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 4000,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "E-Office",
                    font: "Arial",
                    size: 40,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 200,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: formattedDate,
                    font: "Arial",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 200,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Kementerian Investasi dan Hilirisasi/BKPM",
                    font: "Arial",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Infrastructure System",
                    font: "Arial",
                    size: 20,
                    italics: true,
                  }),
                ],
              }),

              // PAGE BREAK
              new Paragraph({
                children: [],
                pageBreakBefore: true,
              }),

              // SECOND PAGE
              new Paragraph({
                spacing: {
                  after: 80,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "HEALTH CHECK & UTILIZATION SUMMARY",
                    font: "Arial",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 80,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Average Disk Space",
                    font: "Arial",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: `Host ${value} - Disk ${disk}`,
                    font: "Arial",
                    color: "000000",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [
                  new ImageRun({
                    data: imgData,
                    transformation: { width: 650, height: 320 },
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "Information :",
                    font: "Arial",
                    color: "000000",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              ...this.getCpuInfoParagraphs(),

              new Paragraph({
                children: [],
                pageBreakBefore: true,
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Analysis & Condition :",
                    font: "Arial",
                    size: 23,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              ...analysisParagraphs,

              new Paragraph({
                spacing: { after: 200 },
                children: [],
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Conclusion :",
                    font: "Arial",
                    size: 23,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.JUSTIFIED,
                children: [
                  new TextRun({
                    text: paragraphText,
                    font: "Arial",
                    size: 20,
                  }),
                ],
              }),
            ],
          },
        ],
      });

      Packer.toBlob(doc).then((blob) => {
        saveAs(blob, "report-maintenance-disk-space.docx");
      });
    });
  };

  allGood = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Good");
  };

  allWarning = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Warning");
  };

  allBad = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Bad");
  };

  analyzeChartData = (chartData) => {
    if (!chartData || !chartData.datasets || chartData.datasets.length === 0) {
      return [];
    }

    const { datasets, labels } = chartData;
    const results = datasets.map((dataset, index) => {
      console.log(dataset);
      const averageUsed = dataset.data[0];
      const averageTotal = Math.abs(dataset.data[1] + dataset.data[0]);

      const selisih = Math.abs(averageTotal - averageUsed);

      const usedPercentage = (averageUsed / averageTotal) * 100;
      const availablePercentage = 100 - usedPercentage;

      let status;
      if (availablePercentage >= 50) {
        status = "Good";
      } else if (availablePercentage >= 20 && availablePercentage < 50) {
        status = "Warning";
      } else {
        status = "Bad";
      }

      return {
        label: labels[index],
        averageUsed: this.convert(averageUsed),
        averageTotal: this.convert(averageTotal),
        availablePercentage: availablePercentage.toFixed(2),
        status: status,
        selisih: this.convert(selisih),
      };
    });

    return results;
  };

  convertImageToBase64 = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      fetch(imageUrl)
        .then((res) => res.blob())
        .then((blob) => {
          reader.onloadend = () => resolve(reader.result.split(",")[1]);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
        .catch(reject);
    });
  };

  getCpuInfoParagraphs = () => {
    const { selectedGraphId } = this.state;
    const { selectedHost } = this.props;

    const hostId = selectedHost.value;

    const specificHost = Array.isArray(this.state.data)
      ? this.state.data.find((item) => item.hostid === hostId)
      : null;

    const graphs =
      specificHost && Array.isArray(specificHost.graphs)
        ? specificHost.graphs
        : [];

    const getGraphIdFromSelected = (selected) => {
      if (!selected || !selected.value) return null;

      const foundGraph = graphs.find((graph) => graph.name === selected.value);
      return foundGraph ? foundGraph.graphid : null;
    };

    const graphId = getGraphIdFromSelected(selectedGraphId);

    const graphItems =
      specificHost && Array.isArray(specificHost.graphs)
        ? specificHost.graphs
            .filter((graph) => graph.graphid === graphId)
            .flatMap((graph) => graph.items)
        : [];

    const usedSpace = graphItems.find(
      (item) =>
        item.name === "/: Used space" || item.name === "/boot: Used space"
    );
    const totalSpace = graphItems.find(
      (item) =>
        item.name === "/: Total space" || item.name === "/boot: Total space"
    );

    const used = usedSpace ? this.convertToBytes(usedSpace.last) : "0.00 GB";
    const total = totalSpace ? this.convertToBytes(totalSpace.last) : "0.00 GB";

    // Menghitung space yang tersedia
    const available = total - used;
    // const availableValue = this.convert(available);

    const sortedItems = [
      {
        name: "Used space",
        value: used,
      },
      {
        name: "Available space",
        value: available,
      },
      {
        name: "Total space",
        value: total,
      },
    ];

    return sortedItems.map(
      (item) =>
        new Paragraph({
          spacing: {
            after: 80,
          },
          children: [
            new TextRun({
              text: `${item.name} - `,
              font: "Arial",
              color: "000000",
              size: 20,
            }),
            new TextRun({
              text: "Nilai:",
              font: "Arial",
              color: "000000",
              size: 20,
              bold: true,
            }),
            new TextRun({
              text: ` ${this.convert(item.value)}`,
              font: "Arial",
              color: "000000",
              size: 20,
            }),
          ],
        })
    );
  };

  render() {
    const { loading, errorMessage } = this.state;
    return (
      <Fragment>
        <Container fluid>
          {loading ? (
            <div className="text-center">
              <div>
                <Spinner
                  style={{
                    width: "3rem",
                    height: "3rem",
                    borderWidth: "0.4rem",
                  }}
                  color="dark"
                />
              </div>
              <div>
                <span style={{ fontWeight: "bold" }}>Mengambil Data ...</span>
              </div>
            </div>
          ) : errorMessage ? (
            <Card className="text-center">
              <br />
              <CardBody>
                <h5 className="text-dark">{errorMessage}</h5>
                <br />
                <Button color="danger" onClick={this.loadData}>
                  Muat Ulang
                </Button>
              </CardBody>
            </Card>
          ) : (
            <div>
              <Row className="d-flex justify-content-between align-items-center">
                <Col md="3">
                  <label>Pilih Disk : </label>
                  <br />
                  <Select
                    options={this.state.diskOption}
                    placeholder="Pilih Penyimpanan"
                    onChange={this.handleGraphIdChange}
                    value={this.state.selectedGraphId}
                  />
                </Col>
                <Col md="2" className="text-right">
                  <label>&nbsp;</label>
                  <br />
                  <Button onClick={this.handleDownloadWord} color="primary">
                    <span className="uil-cloud-download"></span> Unduh Data
                  </Button>
                </Col>
              </Row>
              <hr />
              <div>
                <div>
                  <Pie
                    ref={(ref) => (this.chartRef = ref && ref.chartInstance)}
                    data={this.createChart()}
                    options={{
                      responsive: true,
                      plugins: {
                        legend: {
                          position: "top",
                        },
                        tooltip: {
                          callbacks: {
                            label: function (context) {
                              return context.raw + "%";
                            },
                          },
                        },
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          <Row>
            <Col className="col-12">{this.renderDiskInfo()}</Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default withRouter(IndexView);
